<template>
  <div class="not-found-container">
    <el-row type="flex" justify="center" align="middle">
      <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="12">
        <el-card class="not-found-card">
          <div class="not-found-content">
            <div class="error-code">404</div>
            <div class="error-icon">
              <i class="el-icon-warning-outline"></i>
            </div>
            <h2 class="error-title">页面未找到</h2>
            <p class="error-message">抱歉，您访问的页面不存在或已被删除</p>
            <div class="error-actions">
              <el-button type="primary" @click="goHome" icon="el-icon-house">
                返回首页
              </el-button>
              <el-button @click="goBack" icon="el-icon-back">
                返回上一页
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/home')
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found-container {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  .not-found-card {
    text-align: center;
    padding: 60px 40px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    
    .not-found-content {
      .error-code {
        font-size: 120px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
        margin-bottom: 20px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
      }
      
      .error-icon {
        font-size: 80px;
        color: #E6A23C;
        margin-bottom: 20px;
        animation: shake 0.5s ease-in-out;
        
        i {
          display: inline-block;
        }
      }
      
      .error-title {
        font-size: 28px;
        color: #303133;
        margin-bottom: 15px;
        font-weight: 600;
      }
      
      .error-message {
        font-size: 16px;
        color: #606266;
        margin-bottom: 30px;
        line-height: 1.6;
      }
      
      .error-actions {
        display: flex;
        justify-content: center;
        gap: 15px;
        flex-wrap: wrap;
        
        .el-button {
          padding: 12px 30px;
          font-size: 16px;
        }
      }
    }
  }
}

@keyframes shake {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  75% {
    transform: rotate(10deg);
  }
}

@media (max-width: 768px) {
  .not-found-container {
    .not-found-card {
      padding: 40px 20px;
      
      .not-found-content {
        .error-code {
          font-size: 80px;
          margin-bottom: 15px;
        }
        
        .error-icon {
          font-size: 60px;
          margin-bottom: 15px;
        }
        
        .error-title {
          font-size: 22px;
          margin-bottom: 12px;
        }
        
        .error-message {
          font-size: 14px;
          margin-bottom: 25px;
        }
        
        .error-actions {
          flex-direction: column;
          gap: 10px;
          
          .el-button {
            width: 100%;
            padding: 10px 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
